import { base } from './';

export interface IPermission {
  id: number;
  code: string;
  description?: string;
}

const PATH = '/permissions';

const getAll = () => base.get<IPermission[]>(PATH);

export { getAll };
